import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchChat, fetchChatCreate, editChat,
} from "Actions/Admin/Program/ChatActions";



/**
 * The Program Chat Edit Dialog
 */
class ChatEdit extends React.Component {
    // The Initial Data
    initialData = {
        chatID       : 0,
        programID    : 0,
        name         : "",
        description  : "",
        videoLink    : "",
        position     : 0,
        status       : Status.getID("ACTIVE"),
        observations : "",
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, programID, position, fetchChat, fetchChatCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchChat(elemID);
                loading = true;
            // Load edit data
            } else if (programID) {
                fetchChatCreate(programID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, programID, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editChat(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose } = this.props;
        const { data, loading, errors } = this.state;

        return <EditDialog
            open={open}
            icon="chat"
            title={!!elemID ? "CHATS_EDIT_TITLE" : "CHATS_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                name="name"
                label="CHATS_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                type="textarea"
                name="description"
                label="CHATS_DESCRIPTION"
                value={data.description}
                error={errors.description}
                onChange={this.handleChange}
            />
            <InputField
                name="videoLink"
                label="CHATS_VIDEO"
                value={data.videoLink}
                error={errors.videoLink}
                onChange={this.handleChange}
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getFemSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
            <InputField
                type="textarea"
                name="observations"
                label="GENERAL_OBSERVATIONS"
                value={data.observations}
                onChange={this.handleChange}
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchChat       : PropTypes.func.isRequired,
        fetchChatCreate : PropTypes.func.isRequired,
        editChat        : PropTypes.func.isRequired,
        open            : PropTypes.bool.isRequired,
        onClose         : PropTypes.func.isRequired,
        onSubmit        : PropTypes.func.isRequired,
        edition         : PropTypes.number.isRequired,
        position        : PropTypes.number.isRequired,
        elem            : PropTypes.object.isRequired,
        elemID          : PropTypes.number,
        programID       : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.programChat.edition,
            position : state.programChat.position,
            elem     : state.programChat.elem,
        };
    }
}

export default connect(ChatEdit.mapStateToProps, {
    fetchChat, fetchChatCreate, editChat,
})(ChatEdit);
